module.exports = __webpack_public_path__ + "img/fat3.a51e66c7.png";